import { DocumentType } from './DocumentType';

export type ClientCoordinate = {
    clientID: string;
};

export type ProjectCoordinate = ClientCoordinate & {
    projectID: string;
};

export type CreativeCoordinate = ProjectCoordinate & {
    // can also indicate an animation
    creativeID: string;
};

export type AdCoordinate = CreativeCoordinate & {
    adID: string;
};

export type TearsheetCoordinate = CreativeCoordinate & {
    tearsheetID: string;
};

export type TearsheetAdCoordinate = TearsheetCoordinate & {
    adIndex: string;
};

function isNonEmptyString(x: unknown): x is string {
    return typeof x === 'string' && x !== '';
}

export function inferDocumentType(
    coordinate: Record<string, string>
): DocumentType | undefined {
    // sorry about the big chevron
    if (isNonEmptyString(coordinate.clientID)) {
        if (isNonEmptyString(coordinate.projectID)) {
            if (isNonEmptyString(coordinate.creativeID)) {
                if (isNonEmptyString(coordinate.adID)) {
                    return DocumentType.AD;
                }
                if (isNonEmptyString(coordinate.tearsheetID)) {
                    if (isNonEmptyString(coordinate.adIndex)) {
                        return DocumentType.TEARSHEET_AD;
                    }
                    return DocumentType.TEARSHEET;
                }
                return DocumentType.CREATIVE;
            }
            return DocumentType.PROJECT;
        }
        return DocumentType.CLIENT;
    }
    return undefined;
}
